export default __webpack_public_path__ + "static/media/whirlwind.3837a668.png";